



































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import {
  Table as DataTable,
  SvgIcon,
  Pill,
  Dropdown,
  DropdownItem,
  Input,
} from "@brankas/web-ui";

import {
  Product,
  ProductStatus,
  ProductStatusMap,
} from "@/proto/identity/identity/all_pb";
import {
  TableColumn,
  IntegrationsPayload,
  Integrations,
  IntegrationItem,
  ProductItem,
  UpdateIntegrationPayload,
} from "@/types";
import { ECountryCode } from "@/pagesCom/ClientInfo/index.dto";
import { ValueOf } from "@/utils/type-utils";
import { toTitleCase } from "@/utils/common-utils";

import ToggleStatusDialog from "./components/ToggleStatusDialog";
import Breadcrumb from "./components/CustomBreadcrumb";
import { disabledAdvisoryReasons, enabledAdvisoryReasons } from "@/types/fiService";

const integrationsModule = namespace("integrations");

@Component({
  components: {
    DataTable,
    SvgIcon,
    Pill,
    Dropdown,
    ToggleStatusDialog,
    Breadcrumb,
    DropdownItem,
    Input,
  },
})
export default class FiServices extends Vue {
  @integrationsModule.Action("getIntegrations")
  getIntegrations!: (payload: IntegrationsPayload) => Integrations;

  @integrationsModule.Action("updateIntegrationStatus")
  updateIntegrationStatus!: (payload: UpdateIntegrationPayload) => any;

  @Watch("filter", { deep: true })
  watchFilter() {
    this.fetchData();
  }

  key = 0;
  showToggleStatusPrompt = false;
  toggleStatusTarget: ValueOf<ProductStatusMap> = null;
  isToggleToDisable = false;
  isLoading = false;
  column = {
    product: [
      {
        label: "PRODUCT",
        field: "name",
        sortable: false,
        tdClass: "font-sans font-medium",
        width: "50%",
      },
      {
        label: "ENABLED",
        field: "enabled",
        sortable: false,
        tdClass: "font-sans font-medium",
        width: "16%",
      },
      {
        label: "TOTAL",
        field: "total",
        sortable: false,
        tdClass: "font-sans font-medium",
        width: "16%",
      },
      {
        label: "STATUS",
        field: "productstatus",
        sortable: true,
        tdClass: "font-sans font-medium items-start",
        width: "13%",
      },
      {
        label: "",
        field: "action",
        sortable: false,
        tdClass: "font-sans font-medium",
        width: "5%",
      },
    ],
    integration: [
      {
        label: "FINANCIAL INSTITUTION",
        field: "title",
        sortable: true,
        tdClass: "font-sans font-medium",
      },
      {
        label: "STATUS",
        field: "status",
        sortable: true,
        tdClass: "font-sans font-medium items-start",
        width: "13%",
      },
      {
        label: "",
        field: "action",
        sortable: false,
        tdClass: "font-sans font-medium",
        width: "5%",
      },
    ],
  };
  tableColumns: TableColumn[] = this.column.product;
  selectedToggleData: IntegrationItem | ProductItem = null;
  tableData: IntegrationItem[] | ProductItem[] = [];
  selectedCountryName = ECountryCode.PH;
  selectedBankCode = null;
  selectedProduct = null;
  fiSearchValue = "";
  productStatusMap = {
    [ProductStatus.UNKNOWN_PRODUCT_STATUS]: {
      pillType: "default",
      name: this.getProductStatusName(ProductStatus.UNKNOWN_PRODUCT_STATUS),
    },
    [ProductStatus.ENABLED]: {
      pillType: "success",
      name: this.getProductStatusName(ProductStatus.ENABLED),
    },
    [ProductStatus.DISABLED]: {
      pillType: "error",
      name: this.getProductStatusName(ProductStatus.DISABLED),
    },
    [ProductStatus.PARTIAL]: {
      pillType: "warning",
      name: this.getProductStatusName(ProductStatus.PARTIAL),
    },
  };

  get ProductStatus() {
    return ProductStatus;
  }

  get navigations() {
    return [
      {
        label: this.selectedCountryName.toUpperCase(),
        onClick: () => {
          this.selectedProduct = null;
        },
      },
      {
        label: this.selectedProductName.toUpperCase(),
      },
    ];
  }

  get filter(): IntegrationsPayload {
    return {
      country: this.selectedCountry,
      bankCode: this.selectedBankCode,
      product: this.selectedProduct,
    };
  }

  get selectedCountry() {
    return Object.keys(ECountryCode).find(
      (key) => ECountryCode[key] === this.selectedCountryName
    );
  }

  get selectedProductName() {
    return (
      Object.keys(Product).find(
        (key) => Product[key] === this.selectedProduct
      ) || ""
    );
  }

  get countryNameList() {
    return [ECountryCode.PH, ECountryCode.ID, ECountryCode.VN];
  }

  get isNotAllowedToSeeDetail() {
    return this.selectedProduct;
  }

  get filteredTableData() {
    return this.selectedProduct
      ? this.tableData.filter((data) =>
          data?.title?.toLowerCase().includes(this.fiSearchValue?.toLowerCase())
        )
      : this.tableData;
  }

  get advisoryReasons() {
    const reasons = this.isToggleToDisable ? disabledAdvisoryReasons : enabledAdvisoryReasons;
    return reasons;
  }

  onCountryClick(country) {
    this.selectedCountryName = country;
  }
  onViewDetailClick(data: IntegrationItem | ProductItem) {
    if (this.isNotAllowedToSeeDetail) return;

    this.selectedProduct = data.product;
  }
  onStatusToggleClick(
    data: IntegrationItem | ProductItem,
    statusTarget?: ValueOf<ProductStatusMap>
  ) {
    this.showToggleStatusPrompt = true;
    this.selectedToggleData = data;
    this.toggleStatusTarget = statusTarget;
    this.isToggleToDisable = this.getIsToggleToDisable(statusTarget);
  }

  getIsToggleToDisable(statusTarget: ValueOf<ProductStatusMap>) {
    switch (statusTarget) {
      case ProductStatus.ENABLED:
        return false;
      case ProductStatus.DISABLED:
        return true;
      default:
        return false;
    }
  }

  getProductStatusName(productstatus: ValueOf<ProductStatusMap>) {
    if (productstatus === ProductStatus.UNKNOWN_PRODUCT_STATUS) {
      return "Unknown";
    }

    return toTitleCase(
      Object.keys(ProductStatus).find(
        (key) => ProductStatus[key] === productstatus
      )
    );
  }

  async fetchData() {
    try {
      this.key += 1;
      this.isLoading = true;
      const productsList = await this.getIntegrations(this.filter);

      if (this.selectedProduct) {
        this.tableColumns = this.column.integration;
        this.tableData = productsList[0].integrationsList.map(
          (integration) => ({
            ...integration,
            action: integration,
          })
        );
      } else {
        this.tableColumns = this.column.product;
        this.tableData = productsList.map((product) => ({
          ...product,
          action: product,
        }));
      }
    } catch (error) {
      console.error("Failed to get integrations", error);
    } finally {
      this.isLoading = false;
    }
  }

  async toggleStatus(data: any) {
    try {
      this.isLoading = true;
      const updatePayload = this.selectedToggleData.id
        ? {
            product: this.selectedToggleData.product,
            country: this.selectedToggleData.country,
            integrationId: this.selectedToggleData.id,
            status: this.toggleStatusTarget,
            ...data,
          }
        : {
            country: this.selectedToggleData.country,
            product: this.selectedToggleData.product,
            productstatus: this.toggleStatusTarget,
            ...data,
          };
      await this.updateIntegrationStatus(updatePayload);

      await this.fetchData();
    } catch (error) {
      console.error("Failed to toggleStatus", error);
    } finally {
      this.showToggleStatusPrompt = false;
      this.selectedToggleData = null;
      this.isLoading = false;
    }
  }

  // Methods
  async mounted() {
    this.fetchData();
  }
}
